import type { VoidFunctionComponent } from 'react';

import type { UsePoliciesSelectionProps } from '../../../hooks/usePoliciesSelection';

import PoliciesSelection from './PoliciesSelection/PoliciesSelection';

import styles from '../../ReleaseGroupsRevamp.module.less';

type Props = UsePoliciesSelectionProps;

const ReleaseGroupsPolicies: VoidFunctionComponent<Props> = (props) => {
  return (
    <section className={styles.section}>
      <PoliciesSelection
        policies={props.policies}
        isLoading={props.isLoading}
        errors={props.errors}
        hasSelectedAtLeastOnePolicy={props.hasSelectedAtLeastOnePolicy}
        selectedPolicies={props.selectedPolicies}
        onUpdateSelectedPolicies={props.onUpdateSelectedPolicies}
        onSaveSelectedPolicies={props.onSaveSelectedPolicies}
        shouldDisplayLicensingPolicies={props.shouldDisplayLicensingPolicies}
        shouldDisplaySecurityPolicies={props.shouldDisplaySecurityPolicies}
        shouldDisplayQualityPolicies={props.shouldDisplayQualityPolicies}
      />
    </section>
  );
};

export default ReleaseGroupsPolicies;
